import createList from '../../with-list';

import qs from 'querystring';

import endpoints from '../../../../config/endpoints';

const namespace = 'bannersImageList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BANNERS.IMAGES,
	perPage: 10,
	getRequestQuery
});

function getRequestQuery(page, getState) {
	const state = getState()[namespace];
	const query = qs.parse(location.search.slice(1));

	const limit = state.pagination.perPage;

	return {
		search: query.search,
		langs: query.langs && query.langs.split(','),
		offset: (page - 1) * limit,
		limit
	};
}

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/image/list/index.js